import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-698d935e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-subtitle-1 font-weight-bold pa-1 bg-grey-lighten-3 border cursor-pointer" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 2,
  class: "mt-2 pl-6"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-3 mb-1" }, "Email when users can contact you.", -1 /* HOISTED */))
const _hoisted_5 = {
  key: 3,
  class: "mt-1"
}
const _hoisted_6 = { class: "text-center text-warning" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "This is an option for paid accounts only!", -1 /* HOISTED */))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "mt-2" }
const _hoisted_10 = { class: "text-center break-word" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Click on the link", -1 /* HOISTED */))
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  key: 0,
  class: "text-center"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "text-center mt-2" }

import { ref, watch, onMounted } from "vue";
import flashMessenger from '../service/FlashMessenger';
import crApi from "../service/CrApi";
import securityService from "../service/SecurityService";
import UtilService from "../service/UtilService";


export default /*#__PURE__*/_defineComponent({
  __name: 'CsvDownloadLinkComponent',
  props: {
  name: {
    type:String,
    default: '1'
  },
  shareUrl: {
    type: Object,
    default: {}
  },
  newName: {
    type: String,
    default: ''
  },
  requireLoginCheckbox: {
    type: Boolean,
    default: false
  },
  allowUsers: {
    type: Boolean,
    default: false
  },
  email: {
    type: String,
    default: ''
  },
  showTitle: {
    type: Boolean,
    default: true
  },
  showSaveDownloadLink: {
    type: Boolean,
    default: true
  },
  showViewDownloadLink: {
    type: Boolean,
    default: true
  },
  showExistingUrl: {
    type: Boolean,
    default: true
  },
  hideDownloadBtn: {
    type: Boolean,
    default: false
  },
  scanFilterStateV2: {
    type: Object,
    default: () => ({})
  },
  prefix: {
    type: [String, Number],
    default: ''
  },
},
  emits: ['update:name', 'update:shareUrl'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;
const shortUrl = ref('');
const modalVisible = ref(false);
const creatingLink = ref(false);
const currentPlanId = ref(null);
const shortUrls = ref([]);
const loadingUrls = ref(true);
const selectedUrlName = ref('');
const downloadLink = ref(false);
const linkName = ref(props.name);
const linkNewName = ref(props.newName);
const isRequireLoginCheckbox = ref(props.requireLoginCheckbox);
const userEmail = ref(props.email);
const allowUsersToChange = ref(props.allowUsers);
const showTitle = ref(props.showTitle);
const accountId = ref(null);
const adminId = ref(null);
const idPrefix = ref();

watch(() => showTitle.value, (newVal) => {
  if (!newVal) {
    downloadLink.value = true
  }
})

watch(() => selectedUrlName.value, (newVal) => {
  const selectedUrl = shortUrls.value.find((url) => url.keyword === newVal)
  if (selectedUrl && selectedUrl['urlParams']) {
    userEmail.value = selectedUrl['urlParams']['contact_email'] || ''
    allowUsersToChange.value = selectedUrl['urlParams']['user_id_confirmed'] === '1'
    isRequireLoginCheckbox.value = userEmail.value !== '' || allowUsersToChange.value
  }
})

watch([() => linkName.value, () => linkNewName.value,() => isRequireLoginCheckbox.value, () => allowUsersToChange.value, () => userEmail.value], () => {
  if(props.shareUrl) {
    const shareObj = props.shareUrl;
    shareObj['shareUrlNameType'] = linkName.value;
    shareObj["urlName"] = linkNewName.value;
    shareObj["requireLoginCheckbox"] = isRequireLoginCheckbox.value;
    shareObj["allowUsers"] = allowUsersToChange.value;
    shareObj["contactEmail"] = userEmail.value

    emit('update:shareUrl', shareObj);
  }
})

onMounted(()=> {
  load();
})

async function load() {
  try {
    const adminResponse = await crApi.requestV2('admin/retrieve/', {website_token: securityService.getToken()});
    if (adminResponse.status === 1 && adminResponse['admin'].length > 0) {
      currentPlanId.value = adminResponse['admin'][0]['planId'];
      accountId.value = adminResponse.admin[0].accountId;
      adminId.value = adminResponse.admin[0].adminId;
    } else {
      await flashMessenger.toastById(adminResponse.error || 'Failed to load admin data', 'warning');
    }
  } catch (error) {
    await flashMessenger.toastById('Error fetching admin details.', 'error');
  }

  try {
    const shortUrlResponse = await crApi.requestV2('short_url/retrieve/', {
      website_token: securityService.getToken(),
      type: 'scans'
    });
    if (shortUrlResponse.status === 1) {
      shortUrls.value = shortUrlResponse['shortUrl'] || [];
      loadingUrls.value = false;
    } else {
      await flashMessenger.toastById(shortUrlResponse.error || 'Failed to load short URLs', 'warning');
    }

    if (!props.showTitle) {
      downloadLink.value = true;
    }

    idPrefix.value = props.prefix == undefined ? "" : props.prefix + "-";
  } catch (error) {
    await flashMessenger.toastById('Error fetching short URLs.', 'error');
  }
}

async function saveDownloadLink() {
  if (creatingLink.value) {
    return;
  }

  if (linkName.value == '3' && !selectedUrlName.value) {
    await flashMessenger.toastById('URL_NAME_IS_MISSING', 'error');
    return;
  }
  creatingLink.value = true;
  modalVisible.value = true;
  shortUrl.value = '';
  if (currentPlanId.value != 1 && isRequireLoginCheckbox.value && userEmail.value != '') {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(String(userEmail.value).toLowerCase())) {
      modalVisible.value = false;
      creatingLink.value = false;
      await flashMessenger.toastById('INVALID_EMAIL', 'error');
      return;
    }
  }

  let globalVars = await crApi.requestV2('globalvar/retrieve/',{variableName: 'apiURL', website_token: securityService.getToken()});

  let apiUrl = '';
  if (globalVars.status == 1) {
    let filterParams = {};
    filterParams['cr_au_id_internal'] = accountId.value;
    filterParams['returnType'] = 'csv';
    if (Object.keys(props.scanFilterStateV2).length) {
      filterParams = Object.assign(filterParams, props.scanFilterStateV2.getParameters());
    }
    if (isRequireLoginCheckbox.value) {
      filterParams['short_url_type'] = 'scans';
      if (userEmail.value != '') {
        filterParams['contact_email'] = userEmail.value;
      }
      if (allowUsersToChange.value) {
        filterParams['user_id_confirmed'] = '1';
      }
      if (props.hideDownloadBtn) {
        filterParams['hide_download_btn'] = 1;
      }
      // let curPort = location.port == '0' || location.port == '' ? '' : ':' + location.port;
      // apiUrl = location.protocol + '//' + location.hostname + curPort + '/share/preview/?' + 'yourls_encrypt_query=1&q=' + JSON.stringify(filterParams);
      apiUrl = '/share/preview/?' + 'yourls_encrypt_query=1&q=' + JSON.stringify(filterParams);
    } else {
      apiUrl = '/api-v2/scan/retrieve/?' + UtilService.serializeParams(filterParams);
    }
  }

  let params = {};
  let sUrlResponse = null;
  if (linkName.value == '3' && (selectedUrlName.value != '' || selectedUrlName.value != null)) {
    let updateParams = {
      website_token: securityService.getToken(),
      keyword: selectedUrlName.value,
      url: apiUrl
    };
    sUrlResponse = await crApi.requestV2('short_url/update/', updateParams);
  } else {
    if (linkName.value == '2' && linkNewName.value != '') {
      params['keyword'] = linkNewName.value;
    }
    params['type'] = 'scans';
    params['url'] = apiUrl;
    params['website_token'] = securityService.getToken();
    sUrlResponse =  await crApi.requestV2('short_url/create/',params);

  }

  if (sUrlResponse.status == 1) {
    shortUrl.value = sUrlResponse.shortUrl;
    creatingLink.value = false;
  } else {
    creatingLink.value = false;
    modalVisible.value = false;
    await flashMessenger.toastById(sUrlResponse.error, 'error');
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (showTitle.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (downloadLink.value = !downloadLink.value))
          }, [
            _createElementVNode("div", _hoisted_1, [
              (!downloadLink.value)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    icon: "mdi-menu-right"
                  }))
                : _createCommentVNode("v-if", true),
              _withDirectives(_createVNode(_component_v_icon, {
                size: "small",
                icon: "mdi-menu-down"
              }, null, 512 /* NEED_PATCH */), [
                [_vShow, downloadLink.value]
              ]),
              _createVNode(_component_v_icon, {
                size: "small",
                icon: "mdi-link-variant"
              }),
              _createTextVNode(" Save CSV Download Link")
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    (downloadLink.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", null, [
            _createVNode(_component_v_radio_group, {
              modelValue: linkName.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((linkName).value = $event)),
              class: "mt-2",
              "hide-details": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_radio, {
                  label: 'Choose a random name',
                  value: "1",
                  density: "compact",
                  class: "my-1"
                }),
                _createVNode(_component_v_radio, {
                  label: 'Enter a name',
                  value: "2",
                  density: "compact",
                  class: "my-1"
                }),
                (__props.showExistingUrl)
                  ? (_openBlock(), _createBlock(_component_v_radio, {
                      key: 0,
                      label: 'Update existing URL',
                      value: "3",
                      density: "compact",
                      class: "my-1"
                    }))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"]),
            (linkName.value == '2')
              ? (_openBlock(), _createBlock(_component_v_text_field, {
                  key: 0,
                  placeholder: "Enter a name",
                  variant: "outlined",
                  modelValue: linkNewName.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((linkNewName).value = $event)),
                  density: "compact",
                  "hide-details": "",
                  class: "mt-2"
                }, null, 8 /* PROPS */, ["modelValue"]))
              : _createCommentVNode("v-if", true),
            (linkName.value == '3')
              ? (_openBlock(), _createBlock(_component_v_select, {
                  key: 1,
                  modelValue: selectedUrlName.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedUrlName).value = $event)),
                  items: shortUrls.value,
                  "item-title": "keyword",
                  "item-value": "keyword",
                  label: "Select a URL",
                  density: "compact",
                  "hide-details": "",
                  class: "mt-2"
                }, null, 8 /* PROPS */, ["modelValue", "items"]))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_v_checkbox, {
              modelValue: isRequireLoginCheckbox.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isRequireLoginCheckbox).value = $event)),
              label: "Require user login",
              class: "my-1",
              density: "compact",
              "hide-details": ""
            }, null, 8 /* PROPS */, ["modelValue"]),
            (isRequireLoginCheckbox.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_v_checkbox, {
                    modelValue: allowUsersToChange.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((allowUsersToChange).value = $event)),
                    label: "Allow user to access scans made by other users",
                    density: "compact",
                    "hide-details": ""
                  }, null, 8 /* PROPS */, ["modelValue"]),
                  _hoisted_4,
                  _createVNode(_component_v_text_field, {
                    variant: "outlined",
                    type: "email",
                    placeholder: "Email",
                    modelValue: userEmail.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((userEmail).value = $event)),
                    density: "compact"
                  }, null, 8 /* PROPS */, ["modelValue"])
                ]))
              : _createCommentVNode("v-if", true),
            (__props.showSaveDownloadLink)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _withDirectives(_createElementVNode("div", _hoisted_6, _hoisted_8, 512 /* NEED_PATCH */), [
                    [_vShow, currentPlanId.value == 1]
                  ]),
                  _createVNode(_component_v_btn, {
                    onClick: saveDownloadLink,
                    color: "black",
                    disabled: currentPlanId.value == 1,
                    class: "w-100"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Save Download Link")
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["disabled"])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_9, [
              (__props.showViewDownloadLink)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: {name: 'account.shorturl'},
                    target: "_blank",
                    class: "text-black text-decoration-underline"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("View My Download Link")
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_v_dialog, {
      modelValue: modalVisible.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((modalVisible).value = $event)),
      width: "800"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { title: "Download CSV" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  (!creatingLink.value)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: shortUrl.value,
                        target: "_blank",
                        class: "text-info"
                      }, _toDisplayString(shortUrl.value), 9 /* TEXT, PROPS */, _hoisted_12))
                    : _createCommentVNode("v-if", true)
                ], 512 /* NEED_PATCH */), [
                  [_vShow, !creatingLink.value]
                ]),
                (creatingLink.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      (linkName.value != '3')
                        ? (_openBlock(), _createElementBlock("h3", _hoisted_14, "Creating download link"))
                        : _createCommentVNode("v-if", true),
                      (linkName.value == '3')
                        ? (_openBlock(), _createElementBlock("h3", _hoisted_15, "Updating download link"))
                        : _createCommentVNode("v-if", true),
                      (creatingLink.value)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 2,
                            icon: "mdi-progress-helper"
                          }))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_v_btn, {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (modalVisible.value = false)),
                    color: "black"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Close")
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})